import { Label } from "@osago/ui";
import { ENTRY_POINTS, type EntryPointKey } from "@/shared/config/referral";

interface EntryPointFieldProps {
  value: EntryPointKey;
  onChange: (value: EntryPointKey) => void;
}

export function EntryPointField({ value, onChange }: EntryPointFieldProps) {
  return (
    <div className="flex flex-col gap-2.5">
      {ENTRY_POINTS.map((entry) => (
        <label key={entry.key} className="flex cursor-pointer items-start gap-2">
          <input
            type="radio"
            name="referral-entry-point"
            value={entry.key}
            checked={entry.key === value}
            onChange={() => onChange(entry.key)}
            className="sr-only"
          />
          <span className="product-radio" />
          <span className="flex flex-col">
            <Label variant="body" as="span">
              {entry.label}
            </Label>
            <Label variant="hint" as="span">
              {entry.hint}
            </Label>
          </span>
        </label>
      ))}
    </div>
  );
}
